import { Component, Input } from '@angular/core';
import { IconSize } from '../../core-data-model/IconSize';

@Component({
    selector: 'numbered-list-icon',
    template: `
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            attr.width="{{ iconSize }}"
            attr.height="{{ iconSize }}"
            version="1.1"
        >
            <defs>
                <path
                    d="M0,53 C0,82.271 23.729,106 53,106 L53,106 C82.271,106 106,82.271 106,53 L106,53 C106,23.729 82.271,0 53,0 L53,0 C23.729,0 0,23.729 0,53 L0,53 Z"
                    id="jm-path-1"
                />
            </defs>
            <g
                id="jm-Person-Page-"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
            >
                <g
                    id="jm-B-Person-page--more-people-added-"
                    transform="translate(-657.000000, -2383.000000)"
                >
                    <g
                        id="jm-Group-21"
                        transform="translate(659.000000, 2385.000000)"
                    >
                        <g id="jm-Group-23">
                            <path
                                d="M53,106 C82.271,106 106,82.271 106,53 C106,23.729 82.271,0 53,0 C23.729,0 0,23.729 0,53 C0,82.271 23.729,106 53,106 Z"
                                id="jm-Stroke-1"
                                stroke="#0092C8"
                                stroke-width="2.4"
                            />
                            <g id="jm-Group-6">
                                <mask id="jm-mask-2" fill="white">
                                    <use xlink:href="#jm-path-1" />
                                </mask>
                                <g id="jm-Clip-4" />
                                <polygon
                                    id="jm-Fill-3"
                                    fill="#F3FBFE"
                                    mask="url(#jm-mask-2)"
                                    points="-5 111 111 111 111 -5 -5 -5"
                                />
                                <path
                                    class="svgWrapperShape"
                                    d="M53,106 C82.271,106 106,82.271 106,53 C106,23.729 82.271,0 53,0 C23.729,0 0,23.729 0,53 C0,82.271 23.729,106 53,106 Z"
                                    id="jm-Stroke-5"
                                    stroke="#0092C8"
                                    stroke-width="6.4"
                                    mask="url(#jm-mask-2)"
                                />
                            </g>
                        </g>
                        <path
                            d="M32,31 L32,33.625 L34.8636364,33.625 L34.8636364,41.5 L37.7272727,41.5 L37.7272727,31 L32,31 Z M46.3181818,39.5909091 L74,39.5909091 L74,33.8636364 L46.3181818,33.8636364 L46.3181818,39.5909091 Z M32,44.3636364 L32,47.0358292 L37.7272727,47.0358292 L37.7272727,49.125484 L32,51.6320009 L32,57.7272727 L40.5909091,57.7272727 L40.5909091,55.0550799 L34.8636364,55.0550799 L34.8636364,52.9707695 L40.5909091,50.4615804 L40.5909091,44.3636364 L32,44.3636364 Z M46.3181818,54.8636364 L74,54.8636364 L74,49.1363636 L46.3181818,49.1363636 L46.3181818,54.8636364 Z M32,59.6363636 L32,62.3090909 L37.7272727,62.3090909 L37.7272727,64.9818182 L32,64.9818182 L32,67.6518727 L37.7272727,67.6518727 L37.7272727,70.3246 L32,70.3246 L32,73 L40.5909091,73 L40.5909091,59.6363636 L32,59.6363636 Z M46.3181818,70.1363636 L74,70.1363636 L74,64.4090909 L46.3181818,64.4090909 L46.3181818,70.1363636 Z"
                            id="jm-Fill-1"
                            fill="#3D1C70"
                        />
                    </g>
                </g>
            </g>
        </svg>
    `,
    standalone: false
})
export class NumberListIconComponent {
    @Input()
    iconSize: IconSize;
}
